import { useState } from "react";
import {
  Title,
  Wrapper,
  LoginButton
} from "components/core/Header/styles.header";
import { SubBox } from "components/core/HomePage/styles.homepage";
import { SeparatorLine } from "../Common/styles.common";
import { isMobile } from "helpers/helper";
import OutletSwitchSheet from "./OutletSwitchSheet";

const HeaderMobile = ({ showLogout, showProfile, handleLogout, handleProfile, showSubHeader, sellerDetail, allSellerDetails, toggleLoginModal, isHomePage }) => {
  const [showOutletSwithBottomSheet, setShowOutletSwithBottomSheet] = useState(false);
  const isMweb = isMobile(992);

  if (!isHomePage){
    return <></>
  }

  return (
    <>
      <Wrapper className="d-flex justify-content-between align-items-center home-Header">
        <Title>
          <img
            src="/logos/hp_seller_logo.svg"
            height={isMweb ? "32px" : "36px"}
            width={isMweb ? "88px" : "132px"}
          />
        </Title>
        {showLogout ? (
          <div className="d-flex align-items-center" onClick={handleLogout}>
            <img
              src="/logos/logout_logo.svg"
              height="20px"
              width="20px"
            />
            <span className="fs-14 fw-600 text-red-500 ml-1">Logout</span>
          </div>
        ) : showProfile ? (
          <div className="d-flex align-items-center" onClick={handleProfile} style={{ cursor: 'pointer' }}>
            <img
              src="/logos/seller_profile_logo.svg"
              height={isMweb ? "32px" : "36px"}
              width={isMweb ? "32px" : "36px"}
            />
          </div>
        ) : <LoginButton onClick={toggleLoginModal} style={{ width: isMweb ? "60px" : "80px", height: isMweb ? "40px" : "45px" }}>Login</LoginButton>}
      </Wrapper>

      {showSubHeader && <SeparatorLine mt={"0px"} mb={"0px"} />}
      {showSubHeader && <div className="off-white"><SubBox>
        <div className="d-flex justify-content-between align-items-center">
          <div className="fs-13 w-600 fw-600 medium-dark-gray">
            {sellerDetail?.outlet_name?.length > 20 ? `${sellerDetail.outlet_name.slice(0, 20)}...` : sellerDetail?.outlet_name}&nbsp; • &nbsp;
          </div>

          <div className="fs-13 w-600 fw-600 text-red-500"
            onClick={() => {
              setShowOutletSwithBottomSheet(true);
            }}
          >
            Change Outlet
            <img src={"/logos/chevron-down-large.svg"} className="ml-2" />
          </div>
        </div>
      </SubBox>
      </div>}
      <OutletSwitchSheet
        visible={showOutletSwithBottomSheet}
        onClose={() => setShowOutletSwithBottomSheet(false)}
        allSellerDetails={allSellerDetails}
      />
    </>
  );
};

export default HeaderMobile;
